import React from "react";

type HttpMethod = "POST" | "GET" | "PUT" | "DELETE" | "PATCH";

interface MethodBadgeProps {
  method: HttpMethod | string;
}

const METHOD_STYLES: Record<string, string> = {
  POST: "bg-emerald-100 text-emerald-700 border border-emerald-200",
  GET: "bg-blue-100 text-blue-700 border border-blue-200",
  PUT: "bg-amber-100 text-amber-700 border border-amber-200",
  PATCH: "bg-orange-100 text-orange-700 border border-orange-200",
  DELETE: "bg-red-100 text-red-700 border border-red-200",
};

export const MethodBadge: React.FC<MethodBadgeProps> = ({ method }) => {
  const style = METHOD_STYLES[method] ?? "bg-gray-100 text-gray-600 border border-gray-200";
  return (
    <span className={`text-xs font-bold px-2 py-0.5 rounded font-mono ${style}`}>
      {method}
    </span>
  );
};